module.exports = __webpack_public_path__ + "img/FR13579.53fc9c7b.png";